export const contactsData = {
    email: 'praveensuthar108@gmail.com',
    phone: '+919636360163',
    address: 'Gurgaon - India',
    sheetAPI: ''
}